export default {
    props: {
        fluid: {
            type: Boolean,
            default: false,
        },
        validate: {
            type: Object,
            required: true,
        },
    },
};
